/* eslint-disable import/no-mutable-exports */
import axios from "axios";

//const service = new Service(axios);
const API_URL = process.env.REACT_APP_API_URL;

// Deshabilitar la verificación del certificado SSL
axios.defaults.validateStatus = function (status) {
  return true;
};


export const clientAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  mode: "no-cors",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
  },
});

export const clientAxios8080 = axios.create({
  baseURL: API_URL
});

export const clientAxios6060 = axios.create({
  baseURL: "http://localhost:6060",
  mode: "no-cors",
  headers: {
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
  },
});